import { RESET_PASSWORD } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case RESET_PASSWORD.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
        error: {},
      };
    case RESET_PASSWORD.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case RESET_PASSWORD.LOAD:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
